import ical from 'ical.js'
import {DatesIterator} from '../../administration/workSchedule/utils'

const MAX_HOLIDAY_NAME_LENGTH = 80

export class ICalParser {

    parseHolidays(file, year, successCallback, errorCallback) {
        let reader = new FileReader()

        reader.onload = () => {
            let icalData = reader.result

            try {
                successCallback(this.parseHolidayFromText(icalData, year))
            } catch (error) {
                errorCallback(error)
            }
        }

        reader.readAsText(file)
    }

    parseHolidayFromText(text, year) {
        let data = ical.parse(text)
        let comp = new ical.Component(data);

        let allICalHolidays = comp.getAllSubcomponents("vevent")
        let allHolidays = []

        allICalHolidays
        .filter((event) => {
            return new Date(event.getFirstPropertyValue("dtstart").year,
                            event.getFirstPropertyValue("dtstart").month - 1,
                            event.getFirstPropertyValue("dtstart").day).getFullYear() === year
        })
        .forEach((event) => {
            let icalTimeStart = event.getFirstPropertyValue("dtstart")
            let icalTimeEnd = event.getFirstPropertyValue("dtend")

            let dayStart = this._createDate(icalTimeStart)

            // if "DTEND" property has "DATE" type,
            // due to "DTEND" property for a "VEVENT" calendar component specifies the non-inclusive end of the event
            // and DatesIterator includes dateTo set dayEnd as previous day
            let dayEnd = !icalTimeEnd ? dayStart
                                      : icalTimeEnd.isDate ? this._createDate(icalTimeEnd).prevDay()
                                                           : this._createDate(icalTimeEnd)

            let iterator = new DatesIterator(dayStart, dayEnd)
            while (iterator.hasNext()) {
                let name = this.createValidString(event.getFirstPropertyValue("summary"))

                allHolidays.push({
                    date: iterator.next(),
                    name: name
                })
            }
        })

        return allHolidays
    }

    createValidString(string) {

        if (string.length > MAX_HOLIDAY_NAME_LENGTH) {
            return string.substring(0, MAX_HOLIDAY_NAME_LENGTH)
        }

        return string
    }

    _createDate(icalTimeStart) {
        return Date.create(icalTimeStart.year, icalTimeStart.month - 1, icalTimeStart.day)
    }
}


// WEBPACK FOOTER //
// ./web/js/parsers/ical/ICalParser.js